import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem 0',
    '& > p': {
      maxWidth: '50%',
    },
  },

  questionsList: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1.5rem',
    flexWrap: 'wrap',
    '& > div': {
      maxWidth: 'calc(50% - 1.5rem)',
    },
  },
}))

export default styles
